import { render, staticRenderFns } from "./FormAddressSummary.vue?vue&type=template&id=98779318&"
import script from "./FormAddressSummary.vue?vue&type=script&lang=js&"
export * from "./FormAddressSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports